import { render, staticRenderFns } from "./BlogLatest.vue?vue&type=template&id=9fbec812&"
import script from "./BlogLatest.vue?vue&type=script&lang=js&"
export * from "./BlogLatest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports